import React from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles } from '@/hooks';
import { guardianColors } from '@/theme/colors';

type Props = { title: string };

export function ProfileContentPlaceholder({ title }: Props) {
  const styles = useStyles();

  return (
    <Stack flex={1} style={styles.root}>
      <Text variant="Font Guardian App/Heading/Heading H5 24px" style={styles.title}>
        {title}
      </Text>
      <Text variant="Font Guardian App/Body/Body 16px Regular" style={styles.description}>
        {STRINGS.guardianProfile.placeholder(title)}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  root: { paddingHorizontal: scale(20), paddingTop: scale(25) },
  title: { color: guardianColors['10'] },
  description: { color: guardianColors['6'], marginTop: scale(12) },
}));
